/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Calendar } from '../../models/calendar';
import { CalendarUpdate } from '../../models/calendar-update';

export interface UpdateCalendar$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: CalendarUpdate
}

export function updateCalendar(http: HttpClient, rootUrl: string, params: UpdateCalendar$Params, context?: HttpContext): Observable<StrictHttpResponse<Calendar>> {
  const rb = new RequestBuilder(rootUrl, updateCalendar.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Calendar>;
    })
  );
}

updateCalendar.PATH = '/api/v1/calendars/{id}';
